export default __webpack_public_path__ + "static/media/perks.af482f07.png";